// components
import { NoData } from '../NoData';
import EntityCalendarRightClickHandler from './components/EntityCalendarRightClickHandler/EntityCalendarRightClickHandler';

// styles
import { Container } from './CalendarContainer.styles';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';
import CalendarRow from './components/CalendarRow/CalendarRow';

// calendar handlers
import CalendarNavigationHandler from './components/CalendarNavigationHandler/CalendarNavigationHandler';
import CalendarInteractionHandler from './components/CalendarInteractionHandler/CalendarInteractionHandler';

// const
import { SCROLL_CONTAINER_CLASS } from './CalendarContainer.consts';

// utils
import { getSortedCalendars } from 'components/mrp/mrp.utils';
import { useMemo } from 'react';

const CalendarContainer = () => {
  const calendars = useCalendarStore(
    useShallow((state) => getSortedCalendars(state.calendars))
  );

  const calendarIds = useMemo(() => {
    return calendars.map(({ calendarId }) => calendarId);
  }, [calendars]);

  return (
    <EntityCalendarRightClickHandler>
      <Container className={SCROLL_CONTAINER_CLASS}>
        {calendarIds.length === 0 && <NoData />}

        {calendarIds.length > 0 && (
          <CalendarNavigationHandler>
            <CalendarInteractionHandler>
              {calendarIds.map((calendarId) => (
                <CalendarRow key={calendarId} calendarId={calendarId} />
              ))}
            </CalendarInteractionHandler>
          </CalendarNavigationHandler>
        )}
      </Container>
    </EntityCalendarRightClickHandler>
  );
};

export default CalendarContainer;
